import styled, { css } from 'styled-components';
import { ellipsisStyle } from '../../styled/mixins';

export const HorizontalNavigationWrapper = styled.nav`
    width: auto;
    color: #1e1e1e;
    font-size: 12px;
    text-transform: uppercase;
    overflow: hidden;
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    max-height: 115px;
`;

export const NavListStyled = styled.ul`
    list-style: none;
    height: 100%;
    margin: 0;
    padding: ${({ $isMobile }) => ($isMobile ? '0 16px 10px' : '0 0 10px')};
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    overflow-x: auto;
    position: relative;
    overflow-y: visible;
    -webkit-overflow-scrolling: touch;

    li:not(:last-child) {
        margin-right: 16px;
    }
`;

export const NavItemStyled = styled.li`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 8px;
    position: relative;
    width: 64px;
    height: 84px;
    padding: 16px 4px 4px;
    flex-shrink: 0;
    list-style: none;
    background: ${({ $showWhiteItems, theme }) =>
        $showWhiteItems ? theme.bg.secondaryWhite : 'transparent'};
    border-radius: 4px;
    box-sizing: border-box;
    text-transform: none;
    text-align: center;
    transition: 0.5s;
    cursor: pointer;
    visibility: visible;
    color: ${({ theme }) => theme.text.neutralBlack};
    border: 1px solid ${({ theme }) => theme.borders.primaryBorder};

    &::before {
        content: '';
        display: block;
        position: absolute;
        top: -5px;
        left: 0;
        width: 100%;
        height: 4px;
        border-radius: 3px 3px 0 0;
        background: ${({ theme }) => theme.borders.accentBorder};
        transition: top 0.3s;
    }

    ${({ $live }) =>
        $live &&
        css`
            background: ${({ theme }) => theme.bg.semanticErrorBackgroundLight};
            color: ${({ theme }) => theme.text.liveRedDark};
            border-color: transparent;
            transition: 0s;
        `};

    ${({ $isActive }) =>
        $isActive &&
        css`
            background: ${({ theme }) => theme.bg.secondaryWhite};

            &::before {
                top: 0;
            }
        `};
`;

export const SportIcon = styled.div`
    height: 32px;
    width: 32px;
    margin: 0 auto;
    flex-shrink: 0;
`;

export const SportImg = styled.img`
    position: relative;
    width: 32px;
    height: 32px;
    z-index: 1;
`;

export const CountryFlag = styled.img`
    position: absolute;
    z-index: 0;
    display: block;
    right: 5px;
    top: 6px;
`;

export const SignWrapper = styled.div`
    width: 100%;
    min-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Sign = styled.div`
    font-size: ${({ $fontSize }) => $fontSize || '10px'};
    font-weight: 700;
    line-height: 12px;
    letter-spacing: 0.1px;
    ${ellipsisStyle};
    text-align: center;
`;

export const DateIcon = styled.div`
    z-index: 1;
    position: absolute;
    left: 26.5px;
    top: 30px;
    color: #000;
    font-size: 10px;
    font-weight: 700;
    line-height: 12px;
`;
